import _regeneratorRuntime from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
import _asyncToGenerator from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-67b8d6f2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrap"
};
var _hoisted_2 = ["innerHTML"];
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getCertificate } from '@/api/certificate';
export default {
  __name: 'index',
  props: {
    show: Boolean
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var _store$getters$getUse, _store$getters$getUse2;
    var __emit = _ref.emit;
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var props = __props;
    var emit = __emit;
    var showCertificate = ref(true);
    watch(function () {
      return props.show;
    }, function (val) {
      showCertificate.value = val;
    });
    var name = ref(((_store$getters$getUse = store.getters.getUserSelection) === null || _store$getters$getUse === void 0 ? void 0 : _store$getters$getUse.name) || ((_store$getters$getUse2 = store.getters.getUser) === null || _store$getters$getUse2 === void 0 ? void 0 : _store$getters$getUse2.nickname) || '');
    function handleSubmitClick() {
      return _handleSubmitClick.apply(this, arguments);
    }
    function _handleSubmitClick() {
      _handleSubmitClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (name.value) {
                _context.next = 3;
                break;
              }
              _Toast({
                message: '请输入您的姓名',
                position: 'bottom'
              });
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return getCertificate({
                name: name.value,
                questionActiveKey: route.query.questionActiveKey
              }, {
                headers: {
                  'CQ-MEMBER-TOKEN': store.getters.getToken
                }
              });
            case 6:
              res = _context.sent;
              if (res.ok) {
                _Toast({
                  message: '领取成功',
                  position: 'center'
                });
                showCertificate.value = false;
                setTimeout(function () {
                  router.push({
                    path: '/person/certificate',
                    query: _objectSpread(_objectSpread({}, route.query), {}, {
                      name: name.value
                    })
                  });
                }, 500);
              } else {
                _Toast({
                  message: '领取失败',
                  position: 'center'
                });
              }
              _context.next = 12;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 10]]);
      }));
      return _handleSubmitClick.apply(this, arguments);
    }
    var handleCloseClick = function handleCloseClick() {
      emit('close');
    };
    var dialogTitle = computed(function () {
      var title = store.getters.getCertificateTitle;
      return title.split('\n').map(function (item) {
        return "<p class=\"tips\">".concat(item, "</p>");
      }).join('');
    });
    var subtmitBtnText = computed(function () {
      return store.getters.getCertificateSubmitBtnText;
    });
    var titleStyle = computed(function () {
      return {
        textAlign: store.getters.getCertificateTitleAlign || 'left'
      };
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(_Overlay), {
        show: showCertificate.value
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
            style: _normalizeStyle(titleStyle.value),
            innerHTML: dialogTitle.value
          }, null, 12, _hoisted_2), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return name.value = $event;
            }),
            class: "name-input",
            type: "text",
            placeholder: "请输入您的姓名"
          }, null, 512), [[_vModelText, name.value]]), _createVNode(_unref(_Button), {
            onClick: handleSubmitClick,
            class: "submit-btn"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(subtmitBtnText.value), 1)];
            }),
            _: 1
          }), _createVNode(_unref(_Icon), {
            class: "close-btn",
            onClick: handleCloseClick,
            color: "#C2C2C2",
            size: "24px",
            name: "cross"
          })])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
};